var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",on:{"click":function($event){return _vm.onclick()}}},[_c('img',{staticClass:"item-icon",attrs:{"src":_vm.src}}),_c('span',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }